<template>
    <main>
        <!-- <div id="heroSlider" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#heroSlider" data-slide-to="0" class="active"></li>
        <li data-target="#heroSlider" data-slide-to="1"></li>
        <li data-target="#heroSlider" data-slide-to="2"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <section class="hero">
            <div class="container">
              <h1>
                <span>Affordable</span>
                <span class="big">Buying</span>
                <span>with RedBuyers</span>
              </h1>
            </div>
          </section>
        </div>
        <div class="carousel-item">
          <section class="hero">
            <div class="container">
              <h1>
                <span>Affordable</span>
                <span class="big">Buying</span>
                <span>with RedBuyers</span>
              </h1>
            </div>
          </section>
        </div>
        <div class="carousel-item">
          <section class="hero">
            <div class="container">
              <h1>
                <span>Affordable</span>
                <span class="big">Buying</span>
                <span>with RedBuyers</span>
              </h1>
            </div>
          </section>
        </div>
      </div>
    </div> -->
        <!-- <section>
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    :listFor="'NEWLY_ADDED_MLS_HOMES'"
                    key="Newly Added Homes"
                    heading="Newly Added Homes"
                ></inline-properties-carousel>
            </div>
        </section> -->

        <!--  <home-properties-tabs :hideHeading="false"></home-properties-tabs> -->

        <!-- <section class="pt-0">
            <div class="container">
                <inline-properties-carousel :user_id="user_id" listFor="RECENTLY_SOLD_HOMES" key="Recently Sold Homes"
                    heading="Recently Sold Homes"></inline-properties-carousel>
            </div>
        </section> -->

        <!-- <section class="pt-0">
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    listFor="EXCLUSIVE_OFF_MARKET"
                    key="Off Market Homes"
                    heading="RedBuyers Exclusive - Off Market Homes"
                ></inline-properties-carousel>
            </div>
        </section> -->

        <!--   <section class="pt-0">
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    listFor="BUILDER_DEALS"
                    key="Builder Deals"
                    heading="Builder Deals"
                ></inline-properties-carousel>
            </div>
        </section> -->

        <!-- <section class="pt-0">
            <div class="container">
                <inline-properties-carousel :user_id="user_id" listFor="RENTAL_DEALS" key="Rental Deals"
                    heading="Rental Deals"></inline-properties-carousel>
            </div>
        </section> -->

        <!-- <section class="pt-0">
            <div class="container">
                <div class="d-block d-sm-none mb-4 pb-1">
                    <h2 class="heading text-center mb-2">
                        RedBuyers Technology Tools
                    </h2>
                    <p class="text-center">Tools to help you</p>
                </div>
                <div class="navigation-img-grid">
                    <a href="/idx-listings/search-result">
                        <img class="img-fluid" src="/assets/new-buy/images/rb-technology-tools.png"
                            alt="Browse Homes" />
                        <h4>RedBuyers Technology Tools</h4>
                    </a>
                    <a href="/find-your-home-value">
                        <img class="img-fluid" src="/assets/new-buy/images/find-your-home-value.png"
                            alt="Browse Homes" />
                        <h4>Find Your Home Value</h4>
                    </a>
                    <a href="#">
                        <img class="img-fluid" src="/assets/new-buy/images/mortgage-calculator.png"
                            alt="Browse Homes" />
                        <h4>Mortgage Calculator</h4>
                    </a>
                    <a href="#">
                        <img class="img-fluid" src="/assets/new-buy/images/how-much-you-qualify.png"
                            alt="Browse Homes" />
                        <h4>How Much You Qualify</h4>
                    </a>
                </div>
            </div>
        </section> -->
        <!-- <section class="pt-0">
            <div class="container">
                <div class="row align-items-center gy-4">
                    <div class="col-md-7">
                        <img
                            class="img-fluid d-block pe-sm-4"
                            src="assets/new-home/images/video-preview.png"
                            alt="Video preview"
                        />
                    </div>
                    <div class="col-md-5">
                        <div class="text-center">
                            <h3 class="fw-bold">
                                REVOLUTIONIZING THE SELLING & BUYING EXPERIENCE
                            </h3>
                            <p class="text-grey">
                                With over two decades of experience, we stand as
                                the one of top-producing brokerage in Ontario.
                                Introducing technology-driven solutions for
                                sellers, ensuring assured sales, and providing
                                affordable buying options for buyers and
                                investors. Discover more here.
                            </p>
                            <a href="/contact-us" class="contact-us-btn"
                                >Contact Us</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <section class="new-image">
            <div class="content">
                <h1>
                    Affordable Buying with
                    <span class="animated-text">RedBuyers .</span>
                </h1>
                <p>
                    RedBuyers provides exclusive listings, off-market deals,
                    co-investment opportunities, subscription-based access, down
                    payment assistance, and creative purchase options like
                    lease-to-own and seller financing.
                </p>
                <div class="search-box mr-3">
                    <img
                        class="icon"
                        src="assets/home_page/img/map-pin.png"
                        alt=""
                    />

                    <input
                        type="text"
                        :placeholder="placeholder"
                        @focus="onSearchFocus"
                        @blur="onSearchBlur"
                        v-model="city"
                    />
                    <div class="dropdown" v-if="!hideBuySellOptions">
                        <button
                            class="btn btn-link dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {{ sale_or_rent === "Sale" ? "Buy" : "Rent" }}
                        </button>
                        <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                        >
                            <a
                                class="dropdown-item"
                                href="javascript:void(0)"
                                @click="handleFilterChange('Sale')"
                                :class="{ active: sale_or_rent === 'Sale' }"
                                >Buy</a
                            >
                            <a
                                class="dropdown-item"
                                href="javascript:void(0)"
                                @click="handleFilterChange('Lease')"
                                :class="{ active: sale_or_rent === 'Lease' }"
                                >Rent</a
                            >
                        </div>
                    </div>
                    <a
                        :href="
                            city
                                ? '/idx-listings/search-result/?city=' + city
                                : 'javascript:void(0)'
                        "
                        class="search-btn btn-md"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="d-inline-block d-sm-none"
                        >
                            <path
                                d="M12.9179 11.6669H12.2595L12.0262 11.4419C12.547 10.8369 12.9276 10.1242 13.1408 9.3549C13.354 8.5856 13.3946 7.77868 13.2595 6.99189C12.8679 4.67522 10.9345 2.82522 8.6012 2.54189C7.78088 2.43811 6.94769 2.52337 6.16539 2.79113C5.38308 3.0589 4.6724 3.50207 4.08773 4.08675C3.50305 4.67143 3.05987 5.38211 2.79211 6.16441C2.52434 6.94671 2.43909 7.7799 2.54287 8.60022C2.8262 10.9336 4.6762 12.8669 6.99287 13.2586C7.77966 13.3936 8.58658 13.3531 9.35588 13.1398C10.1252 12.9266 10.8378 12.546 11.4429 12.0252L11.6679 12.2586V12.9169L15.2095 16.4586C15.5512 16.8002 16.1095 16.8002 16.4512 16.4586C16.7929 16.1169 16.7929 15.5586 16.4512 15.2169L12.9179 11.6669ZM7.91787 11.6669C5.84287 11.6669 4.16787 9.99189 4.16787 7.91689C4.16787 5.84189 5.84287 4.16689 7.91787 4.16689C9.99287 4.16689 11.6679 5.84189 11.6679 7.91689C11.6679 9.99189 9.99287 11.6669 7.91787 11.6669Z"
                                fill="white"
                            />
                        </svg>
                        <span class="btn-text">Search</span>
                    </a>
                    <div
                        class="list-group city-dropdown"
                        v-if="isDropdownVisible"
                    >
                        <a
                            v-for="city in filteredCities"
                            href="javascript:void(0)"
                            class="list-group-item list-group-item-action"
                            @click="(e) => handleSelectCity(e, city)"
                        >
                            {{ city }} city
                        </a>
                        <a
                            v-for="community in filteredCommunities"
                            href="javascript:void(0)"
                            class="list-group-item list-group-item-action"
                            @click="(e) => handleSelectCity(e, community)"
                        >
                            {{ community }} community
                        </a>
                        <a
                            v-for="property in suggestedProperty"
                            href="javascript:void(0)"
                            class="list-group-item list-group-item-action"
                            @click="(e) => handleProperty(e, property)"
                        >
                            <div class="d-flex">
                                <img
                                    :src="property.images"
                                    alt="Image not found"
                                    style="
                                        width: 50px;
                                        height: 50px;
                                        border-radius: 50%;
                                    "
                                />

                                <div class="d-flex flex-column">
                                    <div class="flex flex-col">
                                        <span class="text-lg font-semibold">{{
                                            property.address
                                        }}</span>
                                        <span class="text-gray-600">{{
                                            property.city
                                        }}</span>
                                        <span class="text-gray-500">{{
                                            property.mls_number
                                        }}</span>
                                        <span class="text-gray-700 font-medium"
                                            >${{ property.price }}</span
                                        >
                                        <span class="text-gray-500">{{
                                            property.zip
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="ImpactContainer">
                <div class="ImpactCardContainer">
                    <div class="ImpactCard">
                        <div class="ImpactIcon">
                            <img
                                src="assets/new-home/images/findyourhomev2.svg"
                                alt="Image not found"
                            />
                        </div>
                        <h1>Personalized search.</h1>
                        <p>
                            Find your home, your way with our customizable
                            search tool, personalized property recommendations
                            and market insights.
                        </p>

                        <!--    href="{{ url('/idx-listings/search-result') }}" -->
                        <a
                            href="/idx-listings/search-result"
                            class="ImpactButton"
                            >Get connected</a
                        >
                    </div>

                    <div class="ImpactCard">
                        <div class="ImpactIcon">
                            <img
                                src="assets/new-home/images/knowyourbudgetv2.svg"
                                alt="Image not found"
                            />
                        </div>
                        <h1>Financial tools</h1>
                        <p>
                            From calculating your budget to choosing a mortgage,
                            we’ve got the financial tools and resources to help
                            you make informed decisions.
                        </p>
                        <button class="ImpactButton">Get pre-approved</button>
                    </div>

                    <div class="ImpactCard">
                        <div class="ImpactIcon">
                            <img
                                src="assets/new-home/images/findanagentv2.svg"
                                alt="Image not found"
                            />
                        </div>
                        <h1>Expert guidance</h1>
                        <p>
                            We'll match you with industry experts, like
                            experienced local agents and RBC® mortgage
                            specialists, so you get the support you need, when
                            you need it.
                        </p>
                        <a href="/contact-us" class="ImpactButton"
                            >Get connected</a
                        >
                    </div>
                </div>
            </div>
        </section>
        <section class="pt-0">
            <div class="container">
                <div class="navigation-img-grid column-2">
                    <!-- <a href="#">
                        <img class="img-fluid" src="assets/new-home/images/mortgage-tools.png" alt="Browse Homes">
                        <h4>Mortgage Tools</h4>
                    </a> -->
                    <a href="/exclusive-property/search-result">
                        <img
                            class="img-fluid"
                            src="assets/new-home/images/down-payment-match.png"
                            alt="Browse Homes"
                        />
                        <h4>Off-Market</h4>
                        <h6>
                            Deals you can’t <br />
                            find anywhere else
                        </h6>
                    </a>

                    <a href="/co-investment">
                        <img
                            class="img-fluid"
                            src="assets/new-home/images/co-buying-img .jpg"
                            alt="Browse Homes"
                        />
                        <h4>Co-Buying</h4>
                        <h6>
                            2 or more people <br />
                            buying a home togeter
                        </h6>
                    </a>

                    <a href="/buying-option">
                        <img
                            class="img-fluid"
                            src="assets/new-home/images/down-payment .jpg"
                            alt="Browse Homes"
                        />
                        <h4>Down Payment Assistance</h4>
                        <h6>
                            Buyer put 10% <br />
                            We match additional 10%
                        </h6>
                    </a>
                    <a href="idx-listings/search-result">
                        <img
                            class="img-fluid"
                            src="assets/new-home/images/cashback.jpg"
                            alt="Browse Homes"
                        />
                        <h4>1% Cash Back</h4>
                        <h6>
                            We gave 1% <br />
                            cash back for MLS listed homes
                        </h6>
                    </a>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    :listFor="'NEWLY_ADDED_MLS_HOMES'"
                    key="Newly Added Homes"
                    heading="Newly Added Homes"
                ></inline-properties-carousel>
            </div>
        </section>

        <section class="pt-0">
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    listFor="RECENTLY_SOLD_HOMES"
                    key="Recently Sold Homes"
                    heading="Recently Sold Homes"
                ></inline-properties-carousel>
            </div>
        </section>

        <section class="pt-0">
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    listFor="EXCLUSIVE_OFF_MARKET"
                    key="Off Market Homes"
                    heading="RedBuyers Exclusive - Off Market Homes"
                ></inline-properties-carousel>
            </div>
        </section>

        <!-- <section class="pt-0">
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    key="Power of Sales"
                    heading="Power of Sales"
                ></inline-properties-carousel>
            </div>
        </section>

        <section class="pt-0">
            <div class="container">
                <inline-properties-carousel
                    :user_id="user_id"
                    key="Price Change"
                    heading="Price Change"
                ></inline-properties-carousel>
            </div>
        </section> -->
    </main>
</template>
<script>
import InlinePropertiesCarousel from "../../components/InlinePropertiesCarousel/InlinePropertiesCarousel.vue";
export default {
    name: "BuyNewPage",
    mounted() {
        let citiesArray = JSON.parse(this.Allcities);
        if (citiesArray.length > 0) {
            for (let i = 0; i < citiesArray.length; i++) {
                this.cities.push(citiesArray[i].city);
            }
        }

        let communitiesArray = JSON.parse(this.Allcommunity);
        if (communitiesArray.length > 0) {
            for (let i = 0; i < communitiesArray.length; i++) {
                this.communities.push(communitiesArray[i].community);
            }
        }
    },
    props: {
        user_id: "",
        Allcities: {
            default() {
                return [];
            },
        },
        Allcommunity: {
            default() {
                return [];
            },
        },
        hideBuySellOptions: {
            default: false,
        },
    },
    data() {
        return {
            cities: [],
            communities: [],
            city: "",
            showCityDropdown: false,
            suggestedProperty: [],
            debounceTimer: null,
            sale_or_rent: "Sale",
        };
    },

    methods: {
        onSearchFocus() {
            this.showCityDropdown = true;
        },
        onSearchBlur() {
            setTimeout(() => {
                this.showCityDropdown = false;
            }, 300);
        },
        handleSelectCity(e, city) {
            this.city = city;

            window.location.href = `/idx-listings/search-result/?city=${city}&sale_or_lease=${this.sale_or_rent}`;
        },
        handleFilterChange(filter) {
            this.sale_or_rent = filter;
        },
        async fetchData() {
            try {
                const response = await axios.get(
                    " https://valuation.santhoshmathew.com/api/v1/get-search-property-suggestion",
                    {
                        params: { search: this.city },
                    }
                );
                this.suggestedProperty = response.data.data.map((data) => ({
                    images: data.photos?.[0] || "fallback-image.jpg", // Avoid errors if `photos` is undefined
                    city: data.city,
                    county: data.county,
                    price: data.list_price,
                    mls_number: data.mls_number,
                    zip: data.zip,
                    address: data.address,
                    unique_id: data.unique_id,
                }));
            } catch (err) {
                console.error("Error fetching data:", err); // Always log errors for debugging
            }
        },

        convertToSlug(val) {
            return val
                .toLowerCase()
                .replace(/[^\w ]+/g, "")
                .replace(/ +/g, "-");
        },

        handleProperty(e, property) {
            window.location.href =
                "/sellers/property-details/" +
                this.convertToSlug(
                    property.address +
                        "," +
                        property.county +
                        "," +
                        this.zip +
                        "," +
                        this.city
                ) +
                "/" +
                property.unique_id;
        },
    },
    computed: {
        filteredCities() {
            return this.cities.filter((city) =>
                city?.toLowerCase()?.startsWith(this.city?.toLowerCase())
            );
        },
        filteredCommunities() {
            return this.communities.filter((community) =>
                community?.toLowerCase()?.startsWith(this.city?.toLowerCase())
            );
        },

        isDropdownVisible() {
            return this.showCityDropdown;
        },
    },
    watch: {
        city(newCity) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                if (newCity) {
                    this.fetchData();
                }
            }, 500);
        },
    },
    components: {
        "inline-properties-carousel": InlinePropertiesCarousel,
    },
};
</script>
<style lang="scss" scoped>
.search-box {
    height: 55px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 3px;
    position: relative;

    .fa-map-marker-alt {
        font-size: 18px;
        margin-right: 10px;
    }

    input {
        flex: 1;
        border: none;
        box-shadow: none;
    }

    .dropdown {
        margin-right: 5px;
    }

    .search-btn {
        border-radius: 10px;
        background: #e11f26;
        box-shadow: 1px 1px 4px 0px rgba(0, 97, 223, 0.3);
        height: calc(100% - 6px);
        color: #fff;
        border: none;
        padding-inline: 20px;
        display: flex;
        align-items: center;
    }
}

.dropdown__sort-by {
    button {
        color: #e11f26;
        padding-inline: 0;
    }
}
.dropdown__filter {
    .dropdown-menu {
        min-width: 600px;
        border-radius: 0px 0px 15px 15px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        padding: 25px;

        * {
            font-weight: 500;
            font-size: 14px;
            color: #6e6e73;
        }

        label {
            display: block;
            margin-bottom: 10px;
            font-size: 14px;
        }

        .price-range-wrapper {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .price-range-select-group {
            display: flex;
            align-items: center;
            gap: 10px;

            .form-group {
                margin-bottom: 0 !important;
            }

            select {
                border-radius: 5px !important;
                border: 1px solid #e11f26 !important;
                padding: 0px 10px !important;
                height: 32px !important;
                font-size: 14px !important;
                color: #6e6e73 !important;
            }
        }

        .bed-bath-parking-group {
            display: grid;
            gap: 1rem;
        }
    }
}
.city-dropdown {
    max-height: 250px;
    overflow-y: auto;
    margin-top: 2px;
    position: absolute;
    z-index: 2;
    width: 100%;
    border: 1px solid grey;
    top: 100%;
    left: 0;
    display: block;
    border-radius: 8px;

    a {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
}
</style>
